import { connect } from 'react-redux';

import ProviderSurgeIncentiveSearchTableRecord from './provider-surge-incentive-search-table-record';
import makeGetSurgeIncentiveStatus from '../reducers/selectors/makeGetSurgeIncentiveStatus';
import { providerSurgeIncentiveDeleteRequest } from '../actions';
import ProviderSurgeIncentiveStatus from '../enums/provider-surge-incentive-status';

const makeMapStateToProps = () => {
  const getSurgeIncentiveStatus = makeGetSurgeIncentiveStatus();

  return (state, ownProps) => {
    const surgeIncentiveStatus = getSurgeIncentiveStatus(state, ownProps);

    return {
      surgeIncentiveStatus,
      canBeModified: surgeIncentiveStatus !== ProviderSurgeIncentiveStatus.FINISHED
    };
  };
};

const mapDispatchToProps = {
  deleteSurgeIncentive: providerSurgeIncentiveDeleteRequest.start
};

export default connect(
  makeMapStateToProps,
  mapDispatchToProps
)(ProviderSurgeIncentiveSearchTableRecord);
